export default __webpack_public_path__ + "static/media/invitation.aa32d996.svg";